
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BackupRepoDto } from '@/services/Backup/interfaces/index';

@Component
export default class DeleteBackupRepoDialog extends Vue {
  @Prop()
  public readonly backupRepo!: BackupRepoDto;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove Backup Repository: #${this.backupRepo.id}?`;
  }

  public async deleteBackupRepo(): Promise<void> {
    this.$emit('delete', this.backupRepo);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
